import React from 'react';
import { Route } from 'react-router-dom';
import LoginPage from 'pages/LoginPage';
import { getTechId } from 'utils/userManager';

function Unauthorized() {
    return (
        <div>
            <p>Unauthorized to this page!</p>
            <LoginPage />
        </div>
    );
}

function NoTechFound() {
    return (
        <div className="card-panel">
            <h3 className="red-text text-darken-2">
                Your tech id was not found. Please contact your supervisor for assistance.
            </h3>
        </div>
    );
}

const RouteWithSubRoutes = (route) => (
    <Route
        path={route.path}
        exact={route.exact}
        render={props => {
            if (!route.allowAnonymous) {
                if (!route.user) {
                    return <Unauthorized />;
                }
                if (!getTechId(route.user)) {
                    return <NoTechFound />;
                }
            }

            return <route.component {...props} routes={route.routes} />;
        }}
    />
);

export default RouteWithSubRoutes;


// WEBPACK FOOTER //
// ./src/RouteWithSubRoutes.js